import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import React, {useMemo} from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import Icon from "../icon/icon.component.js";
import {ButtonContainer} from "./button.styles.js";
function Button({
  children,
  dataCy,
  translate,
  variant = "contained",
  color = "primary",
  fullWidth,
  disabled,
  size = "medium",
  startIcon,
  startElement,
  endIcon,
  endElement,
  type = "button",
  autoFocus,
  onClick
}) {
  const {
    t
  } = useTranslation();
  const _dataCy = useMemo(() => dataCy || translate || children, [children, dataCy, translate]);
  const textContent = useMemo(() => translate ? t(translate) : children, [children, t, translate]);
  const StartIcon = useMemo(() => {
    if (startIcon) {
      return /* @__PURE__ */ React.createElement(Icon, null, startIcon);
    } else if (startElement) {
      return startElement;
    }
    return void 0;
  }, [startElement, startIcon]);
  const EndIcon = useMemo(() => {
    if (endIcon) {
      return /* @__PURE__ */ React.createElement(Icon, null, endIcon);
    } else if (endElement) {
      return endElement;
    }
    return void 0;
  }, [endElement, endIcon]);
  return /* @__PURE__ */ React.createElement(ButtonContainer, {
    "data-cy": _dataCy,
    className: cmpClassName("button"),
    color,
    disabled,
    size,
    type,
    variant,
    fullWidth,
    startIcon: StartIcon,
    endIcon: EndIcon,
    autoFocus,
    onClick
  }, textContent);
}
export default /* @__PURE__ */ React.memo(Button);
